module.exports = __webpack_public_path__ + "static/media/zeder_services.4c3e771f.png";